////import { setTimeout } from "timers";

ko.bindingHandlers.editorjs = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var value = ko.unwrap(valueAccessor());
        var isReady = false;
        var skipChangeEventProp = allBindings.get('skipPropagatingChangeEvent');

        var shouldSkip = false;

        const editor = new EditorJS({
            placeholder: 'Enter a content...',
            holder: element,
            minHeight: '1px',
            tools: {
                quote: Quote,
                delimiter: Delimiter,
                list: {
                    class: List,
                    inlineToolbar: true,
                },
            },
            autofocus: true,
            onChange: async () => {
                //console.log('333');
                var cnt = await editor.save();

                valueAccessor()({ meta: cnt });

                if (!ko.unwrap(skipChangeEventProp) || shouldSkip) {
                    if (!shouldSkip) {
                        document.dispatchEvent(new CustomEvent('changelog_editor_onchange'));
                    } else {
                        shouldSkip = false;
                        skipChangeEventProp(false);
                    }
                } else {
                    //console.log('SDD');
                    //shouldSkip = true;
                    skipChangeEventProp(false);
                }
            },
            onReady: () => {
                isReady = true;
                if (value && value.meta) {
                    editor.render(ko.toJS(value.meta));
                }
            }
        });

        var initialClear = true;
        var updateFromModel = async function () {
            var val = ko.unwrap(valueAccessor());

            var jsVal = null;
            if (val) {
                jsVal = ko.toJS(val);
            }

            if (isReady) {

                var cv = await editor.save();

                var isEqual = false;

                if (jsVal && jsVal.meta) {

                    delete jsVal.meta.time;
                    delete cv.time;

                    isEqual = objectEquals(jsVal.meta, cv);
                }

                if (jsVal && jsVal.meta && isEqual === false) {
                    editor.clear();
                    editor.render(jsVal.meta);
                } else if (!jsVal || !jsVal.meta) {
                    if (!initialClear) {
                        editor.clear();
                    } else {
                        initialClear = false;
                    }
                }
            }
        };

        ko.computed(updateFromModel, null, { disposeWhenNodeIsRemoved: element });
    }
};

function objectEquals(x, y) {
    'use strict';

    if (x === null || x === undefined || y === null || y === undefined) { return x === y; }
    // after this just checking type of one would be enough
    if (x.constructor !== y.constructor) { return false; }
    // if they are functions, they should exactly refer to same one (because of closures)
    if (x instanceof Function) { return x === y; }
    // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
    if (x instanceof RegExp) { return x === y; }
    if (x === y || x.valueOf() === y.valueOf()) { return true; }
    if (Array.isArray(x) && x.length !== y.length) { return false; }

    // if they are dates, they must had equal valueOf
    if (x instanceof Date) { return false; }

    // if they are strictly equal, they both need to be object at least
    if (!(x instanceof Object)) { return false; }
    if (!(y instanceof Object)) { return false; }

    // recursive object equality check
    var p = Object.keys(x);
    return Object.keys(y).every(function (i) { return p.indexOf(i) !== -1; }) &&
        p.every(function (i) { return objectEquals(x[i], y[i]); });
}